export const AT_MIN_ZOOM_EPSILON = 0.001

export type ContinuousFitZoomDecision =
  | { kind: 'ignore' }
  | {
      kind: 'apply'
      nextMinZoom: number
      nextZoom: number | null
      nextWidth: number
      nextHeight: number
    }

export function resolveContinuousFitZoomUpdate(args: {
  newMin: number
  previousMin: number
  previousZoom: number
  prevWidth: number
  containerWidth: number
  containerHeight: number
}): ContinuousFitZoomDecision {
  if (args.newMin <= 0) {
    return { kind: 'ignore' }
  }

  const widthChanged =
    args.prevWidth === 0 || Math.abs(args.containerWidth - args.prevWidth) > 1

  const wasAtMin =
    args.previousMin > 0 &&
    Math.abs(args.previousZoom - args.previousMin) < AT_MIN_ZOOM_EPSILON

  if (wasAtMin && args.previousZoom > 0 && !widthChanged) {
    return { kind: 'ignore' }
  }

  const nextWidth = args.containerWidth
  const nextHeight = args.containerHeight
  const nextMinZoom = args.newMin

  if (args.previousZoom === 0) {
    return {
      kind: 'apply',
      nextMinZoom,
      nextZoom: args.newMin,
      nextWidth,
      nextHeight,
    }
  }

  if (wasAtMin) {
    const widthShrunk = args.containerWidth < args.prevWidth - 1
    const fitShrunk = args.newMin < args.previousZoom - AT_MIN_ZOOM_EPSILON
    if (widthShrunk && fitShrunk) {
      return {
        kind: 'apply',
        nextMinZoom,
        nextZoom: args.newMin,
        nextWidth,
        nextHeight,
      }
    }
    if (widthChanged && args.newMin > args.previousZoom + AT_MIN_ZOOM_EPSILON) {
      return {
        kind: 'apply',
        nextMinZoom,
        nextZoom: args.newMin,
        nextWidth,
        nextHeight,
      }
    }
    return {
      kind: 'apply',
      nextMinZoom,
      nextZoom: null,
      nextWidth,
      nextHeight,
    }
  }

  if (args.previousZoom < args.newMin) {
    return {
      kind: 'apply',
      nextMinZoom,
      nextZoom: args.newMin,
      nextWidth,
      nextHeight,
    }
  }

  return {
    kind: 'apply',
    nextMinZoom,
    nextZoom: null,
    nextWidth,
    nextHeight,
  }
}
